import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";
// import { ThemeProvider, StyledEngineProvider, createTheme, adaptV4Theme } from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@material-ui/core/styles';
import ReactGA from 'react-ga';
import 'bootstrap/dist/css/bootstrap.min.css';

import * as serviceWorker from './serviceWorker';
import WebSiteApp from './components/WebSite/App';
// import Farmer from './components/Farmer/FarmerComponent';
/* import Grower from './components/Grower/GrowerComponent'; */
import About from './components/AboutUs/AboutusComponent';
import AuthRoute from './components/Auth/AuthRoute';
// import MainRoute from './components/Main/MainRoute';
import MainRoute from './components/Main/components/Main/MainRoute';
// import AgriStack from './components/AgriStack/AgriStackComponent';
import BusinessPartner from './components/BusinessPartner/BusinessPartner';
import {NotificationContainer} from "react-notifications";
// import AppsComponent from './components/Apps/AppsComponent';
// import BecomeBuyerComponent from './components/BecomeBuyer/BecomeBuyer';
import ServicesComponent from './components/Services/ServicesComponent';
import GbrFormsComponent from './components/GBRForms/GbrFormsComponent';
import TermsComponent from './components/T&C/Terms';
import PrivacyComponent from './components/Privacy/Privacy';
// import PricingTabs from './components/pricingTabs/PricingTabs';

import "react-notifications/lib/notifications.css";
import './index.css';
import ExploreProducts from './components/ExploreProducts/ExploreProducts';
// import ProcessedProduct from './components/ProceesedProducts/ProcessedProduct';
// import RawProducts from './components/RawProducts/RawProducts';
// import AgriAssets from './components/AgriAssets/AgriAssets';
import { ScrollToTop } from './components/ScrollTo/ScrollToTop';
// import Club from './components/Club/Club';
import MainService from './components/Main/components/Main/Common/MainService';
// import IAA from './components/IAA/IAA';
// import ExploreInvestement from './components/Investments/ExploreInvestement';
import CBNNetwork from './components/WebSite/CBNNetork/CBNNetwork';
// import ForFarmers from './components/ForFarmers/ForFarmers';
// import ForAgriEntreprenuer from './components/ForAgriEntreprenuer/ForAgriEntreprenuer';
import Agent from './components/Agent/Agent';
import CommunityService from './components/CommunityService/CommunityService';
// import AssetService from './components/AssetService/AssetService';
import FieldSupportService from './components/FieldSupportService/FieldSupportService';
// import ExploreTechnology from './components/ExploreTechnology/ExploreTechnology';
import ProcessingService from "./components/ProcessingService/ProcessingService";
import Collective from './components/Collectives/Collective';
import BillingService from './components/BillingService/BillingService';
import AgriMinerComponent from './components/AgriMiner/AgriMinerComponent';
import ARNNetwork from './components/ARNNetwork/ARNNetwork';
import AgriServiceMarketplace from './components/ExploreProducts/AgriServiceMarketplace/AgriServiceMarketplace';
// import ForManufactures from './components/ForManufactures/ForManufactures';
// import ExploreAnimalCare from './components/ExploreAnimalCare/ExploreAnimalCare';
// import ExplorePlantCare from './components/ExplorePlantCare/ExplorePlantCare';
// import PlantAnimalCare from './components/PlantAnimalCare/PlantAnimalCare';
// import ForAAMC from './components/ForAAMC/ForAAMC';
// import ProductionNetwork from './components/WebSite/ProductionNetwork/ProductionNetwork';
// import OnMarketplaceSell from './components/OnMarketplaceSell/OnMarketplaceSell';
// import SocialMarketplace from './components/SocialMarketplace/SocialMarketplace';
// import RFQ from './components/RFQ/RFQ';
// import ContractManufacturing from './components/ContractManufacturing/ContractManufacturing';
// import ContractFarming from './components/ContractFarming/ContractFarming';
// import Tender from "./components/Tender/Tender";
// import TimelyDelivery from './components/TimelyDelivery/TimelyDelivery';
// import ManufacturingOnDemand from './components/ManufacturingOnDemand/ManufacturingOnDemand';
// import IAAMarketplace from './components/IAAMarketplace/IAAMarketplace';
// import RetailInvestors from './components/RetailInvestors/RetailInvestors';
// import InstitutionalInvestors from './components/InstitutionalInvestors/InstitutionalInvestors';
// import ForFarmerFranchise from './components/ForFarmerFranchise/ForFarmerFranchise'
// import AgriBusiness from './components/AgriBusiness/AgriBusiness';
// import Brands from './components/Brands/Brands';
import './config'
// import AAMCNetwork from './components/WebSite/AAMCNetwork/AAMCNetwork';
// import MarketPlaceQuote from './components/MarketPlaceQuote/MarketPlaceQuote';
// import AssetForInvestment from './components/AssetForInvestment/AssetForInvestment';
import LandingPage from './components/WebSite/LandingPage/LandingPage';
import AgriRetailers from './components/AgriRetailers/AgriRetailers';
// import Request from './components/RequestAc/Request';
// import ForAgriTransporter from './components/ForAgriTransporter/ForAgriTransporter';
import FinancialService from './components/FinancialService/FinancialService';
// import POServices from './components/POServices/POServices';
// import Provenace from './components/POServices/Provenace';
import GBRCareLandingPage from './components/WebSite/GBRCareLandingPage/GBRCareLandingPage';
import FarmerFinacialService from './components/FarmerFinacialService/FarmerFinacialService';
import CareServices from './components/AgriProducers/CareServices/CareServices';
import AssetMarketService from './components/AgriProducers/AssetMarketService/AssetMarketService';
// import CBOClubs from './components/CBOClubs/CBOClubs';
// import ForInputProviders from './components/WebSite/ForInputProviders/ForInputProviders';
import ExploreCareProducts from "./components/ExploreCareProducts/ExploreCareProducts"
// import AdvertisementService from "./components/AdvertisementService/AdvertisementService"


const { user } = MainService.getLocalData();
const {  parentId } = user;


let ConsumerAdmin;
let ClientId;
let ClientSecretKey;
let ClientName;
let AssetverticalID;


if(process.env.REACT_APP_DEVELOPMENT_ENV === "production"){
    ConsumerAdmin = process.env.REACT_APP_CONSUMER_ADMIN_PRODUCTION
    ClientId = process.env.REACT_APP_CLIENT_ID_PRODUCTION
    ClientSecretKey = process.env.REACT_APP_CLIENT_SECRET_PRODUCTION
    ClientName = process.env.REACT_APP_NAME_PRODUCTION
    AssetverticalID = process.env.REACT_APP_ASSETVERTICAL_PRODUCTION
 }
 else if (process.env.REACT_APP_DEVELOPMENT_ENV === "staging"){
    ConsumerAdmin =  process.env.REACT_APP_CONSUMER_ADMIN_STAGING
    ClientId = process.env.REACT_APP_CLIENT_ID_STAGING
    ClientSecretKey = process.env.REACT_APP_CLIENT_SECRET_STAGING
    ClientName = process.env.REACT_APP_NAME_STAGING
    AssetverticalID = process.env.REACT_APP_ASSETVERTICAL_STAGING

 }



window.AppConfigData = {
   ConsumerAdmin:ConsumerAdmin,
   CBNRealm: parentId,
   AssetVerticalId:AssetverticalID,
   AssetVerticalFriendlyName: 'ANIMAL',
   ApiUrlMappCBN: window.appConfig.cbn,


   ClientName: ClientName,
   ClientId:ClientId,
   RedirectUrl: '/',
   Realm: parentId,
   EnterpriseId: ConsumerAdmin,
   ClientSecretKey: ClientSecretKey,
   ApiUrlMapp: window.appConfig,
   analytics: {
       google: window.googleAnalytics
   }
//     //ClientName: 'Agri-App',
//     //Realm: 'Agri-Admin',
//     //EnterpriseId: 'Agri-Admin',
//     //UserType: 'Agri-Investor',
//     //ClientId:'2aca444a-d378-4661-947a-4f75d102324c',
//     ClientName: 'Agri-App',
//     Realm: 'consumer2',
//     EnterpriseId: 'consumer2',
//     UserType: 'AssetOEM',
//     ClientId:'30c667be-1aa3-4f0d-94be-a4176d93558a',
//     RedirectUrl: '/',
//    // ClientSecretKey: 'dc13ff6f-7f55-4779-8a45-f3ab52d9b8aa',
//     ClientSecretKey: '6511ea61-2b7a-47f1-b548-0397c68828ad',
//     AssetVerticalId: 'cffa5ffe-f15e-4a27-9a9e-7bf8b5c5d110',
//     AssetVerticalFriendlyName: 'ANIMAL',
//     ApiUrlMapp: window.appConfig,
//     analytics: {
//         google: window.googleAnalytics
//     }
}



// window.AppConfigData = {
//     ConsumerAdmin:"consumer2",
//     CBNRealm: parentId,
//     AssetVerticalId: 'cffa5ffe-f15e-4a27-9a9e-7bf8b5c5d110',
//     AssetVerticalFriendlyName: 'ANIMAL',
//     ApiUrlMappCBN: window.appConfig.cbn,


//     ClientName: 'GBR1',
//     ClientId:'4f4bb68c-f310-4742-9dbd-dcbbc396f9a3',
//     RedirectUrl: '/',
//     Realm: parentId,
//     EnterpriseId: 'consumer2',
//     ClientSecretKey: '56b50768-f088-40e5-b015-9ec5eefdb213',
//     ApiUrlMapp: window.appConfig,
//     analytics: {
//         google: window.googleAnalytics
//     }
// //     //ClientName: 'Agri-App',
// //     //Realm: 'Agri-Admin',
// //     //EnterpriseId: 'Agri-Admin',
// //     //UserType: 'Agri-Investor',
// //     //ClientId:'2aca444a-d378-4661-947a-4f75d102324c',
// //     ClientName: 'Agri-App',
// //     Realm: 'consumer2',
// //     EnterpriseId: 'consumer2',
// //     UserType: 'AssetOEM',
// //     ClientId:'30c667be-1aa3-4f0d-94be-a4176d93558a',
// //     RedirectUrl: '/',
// //    // ClientSecretKey: 'dc13ff6f-7f55-4779-8a45-f3ab52d9b8aa',
// //     ClientSecretKey: '6511ea61-2b7a-47f1-b548-0397c68828ad',
// //     AssetVerticalId: 'cffa5ffe-f15e-4a27-9a9e-7bf8b5c5d110',
// //     AssetVerticalFriendlyName: 'ANIMAL',
// //     ApiUrlMapp: window.appConfig,
// //     analytics: {
// //         google: window.googleAnalytics
// //     }
// }

const theme = createTheme(
    {
        palette: {
            primary: {main: '#3ECF8E'},
            secondary: {main: '#2F80ED'},
            danger: {main: '#BF360C', shadow: 'rgba(191,54,12 ,.3)'},
        },
        status: {
            danger: 'orange',
        }
    }
);

try{
    ReactGA.initialize(window.AppConfigData.analytics.google.accountId, { debug: false });
    ReactGA.pageview(window.location.pathname + window.location.search);
    //console.log(window.location.pathname + window.location.search);
}catch(e){
    console.error(e);
}

class IndexComponent extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            // history: useHistory()
        }
    }

    
    componentDidMount(){
        localStorage.setItem("Sapna", true);
}

    componentDidUpdate(prevProps, prevState){
       
        if(prevProps.location !== this.props.location){
            ReactGA.pageview(window.location.pathname + window.location.search);
        }
    }

    // createAccessToken(){
    //     fetch(
    //         `${window.appConfig.PublicAccessToken}${window.appConfig.TokenRelam}`,
    //         {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/json",
                 
    //           },
    //           body:JSON.stringify( {
    //             client_name:"GBR1",
    //             client_secret:"56b50768-f088-40e5-b015-9ec5eefdb213"
    //           })
    //         }
    //       ).then((res) => res.json())
    //     .then((result) => {
    //         this.setState({
    //          accessToken: result.access_token,
    //         });
    //         localStorage.setItem("GlobalAccess",result.access_token);

    //     })
    //         .catch((err) => console.log("err", err));
    //   }
    createAccessToken(){
        fetch(
            `${window.appConfig.PublicAccessToken}${window.appConfig.TokenRelam}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                 
              },
              body:JSON.stringify( {
                client_name:ClientName,
                client_secret:ClientSecretKey
              })
            }
          ).then((res) => res.json())
        .then((result) => {
            this.setState({
           });
            localStorage.setItem("GlobalAccess",result.access_token);

        })
            .catch((err) => console.log("err", err));
      }
      componentDidMount(){
        this.createAccessToken();
        // localStorage.setItem("Sapna", false);

      }

    render(){
        return (
            // <StyledEngineProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <Router>
                    <ScrollToTop>
                        <Switch>
                            {/* <Route path="/cbnmain" component={(args) => <CBNMainRoute {...args}/>} /> */}

                            {/* <Route exact path="/agri-storage-entrepreneurs" component={(args) => <WebSiteApp {...args}/>} />
                            <Route exact path="/Farmer" component={(args) => <Farmer {...args}/>} />
                            <Route exact path="/ComingSoon" component={(args) => <Request {...args}/>} />
                            <Route exact path='/onMarketplace' component={(args)=><ExploreProducts {...args}/>}/>
                            <Route exact path="/EngagementServices" component={(args) => <GbrFormsComponent {...args}/>} /> */}
                            {/* <Route exact path='/Services' component={(args)=> <ServicesComponent {...args}/>}/>
                            <Route exact path='/ProcessedProducts' component={(args)=><ProcessedProduct {...args}/>}/>
                            <Route exact path='/RawProducts' component={(args)=><RawProducts {...args}/>}/>
                            <Route exact path='/AgriAssets' component={(args)=><AgriAssets {...args}/>}/>
                            <Route exact path='/Pricing' component={(args)=><PricingTabs {...args}/>}/>
                            <Route exact path='/Club' component={(args)=><Club {...args}/>}/>
                            <Route exact path='/IAA' component={(args)=><IAA {...args}/>} />

                            <Route exact path='/ExploreInvestment' component={(args)=><ExploreInvestement {...args}/>} />
                            <Route exact path='/agri-entreprenur' component={(args)=><ForFarmers {...args}/>} />
                            <Route exact path='/agri-transporters' component={(args)=><ForAgriTransporter {...args}/>} />

                            <Route exact path='/contract-manufacturer' component={(args)=><ForAgriEntreprenuer {...args}/>} />
                            <Route exact path='/FarmerFranchise' component={(args)=><ForFarmerFranchise {...args}/>} />

                            <Route exact path='/profit-generating-services' component={(args)=><AssetService {...args}/>} />
                            <Route exact path='/ExploreTechnology' component={(args)=><ExploreTechnology {...args}/>} />
                            <Route exact path='/ForBrands' component={(args)=><ForManufactures {...args}/>} />
                            <Route exact path='/ExploreAnimalCare' component={(args)=><ExploreAnimalCare {...args}/>}/>
                            <Route exact path='/ExplorePlantCare' component={(args)=><ExplorePlantCare {...args}/>}/>
                            <Route exact path='/Care' component={(args)=><PlantAnimalCare {...args}/>}/>
                            <Route exact path='/ForAAMC' component={(args)=><ForAAMC {...args}/>}/>
                            <Route exact path='/PNNetwork' component={(args)=><ProductionNetwork {...args}/>}/>
                            <Route exact path='/AAMC' component={(args)=><AAMCNetwork {...args}/>}/>
                            <Route exact path="/onMarketplaceRFQ" component={(args)=><MarketPlaceQuote {...args}/>} />

                            <Route exact path="/onMarketplaceSell" component={(args)=><OnMarketplaceSell {...args}/>} />
                            <Route exact path="/SocialCFonMarketplace" component={(args)=><SocialMarketplace {...args}/>} />
                            <Route exact path="/RFQ" component={(args)=><RFQ {...args}/>} />
                            <Route exact path="/SocialCMonMarketplace" component={(args)=><ContractManufacturing {...args}/>} />
                            <Route exact path="/ContractFarming" component={(args)=><ContractFarming {...args}/>} />
                            <Route exact path="/Tender" component={(args)=><Tender {...args}/>} />
                            <Route exact path="/TimelyDelivery" component={(args)=><TimelyDelivery {...args}/>} />
                            <Route exact path="/AgriBusiness" component={(args)=><AgriBusiness {...args}/>} />
                            <Route exact path="/Brands" component={(args)=><Brands {...args}/>} />
                            <Route exact path="/MoD" component={(args)=><ManufacturingOnDemand {...args}/>} />
                            <Route exact path="/iaaMarketplace" component={(args)=><IAAMarketplace {...args}/>} />
                            <Route exact path="/RetailInvestors" component={(args)=><RetailInvestors {...args}/>} />
                            <Route exact path="/AgriInvestors" component={(args)=><InstitutionalInvestors {...args}/>} />
                            <Route exact path="/InvestableAssets" component={(args)=><AssetForInvestment {...args}/>} />
                            <Route exact path="/PO-Services" component={(args)=><POServices {...args}/>} />
                            <Route exact path="/Provenance" component={(args)=><Provenace {...args}/>} />
                            <Route exact path="/cbo-clubs" component={(args)=><CBOClubs {...args}/>} />

                            <Route exact path="/input-manufacturers" component={(args)=><ForInputProviders {...args}/>} />
                            <Route exact path="/advertisement" component={(args)=><AdvertisementService {...args}/>} /> */}



                            {/* <Route exact path='/' component={(args)=><LandingPage {...args}/>} /> */}
                            <Route exact path="/" component={(args) => <GBRCareLandingPage {...args}/>} />
                            <Route exact path="/farmers-financial-services" component={(args)=><FarmerFinacialService {...args}/>} />
                            <Route exact path="/asset-market-services" component={(args)=><AssetMarketService {...args}/>} />
                            <Route exact path="/care-services" component={(args)=><CareServices {...args}/>} />
                            <Route exact path='/Field-Support' component={(args)=><FieldSupportService {...args}/>} />
                            <Route exact path='/customized-cbn-network' component={(args)=><CBNNetwork {...args}/>} />
                            <Route exact path="/About" component={(args) => <About {...args}/>} />
                            <Route exact path='/agri-retailers' component={(args)=><AgriRetailers {...args}/>} />
                            <Route exact path='/customized-arn-network' component={(args)=><ARNNetwork {...args}/>} />
                            
                            <Route exact path='/Community' component={(args)=><CommunityService {...args}/>} />

                            <Route exact path='/GrowthService' component={(args)=><ProcessingService {...args}/>} />
                            <Route exact path="/financial-services" component={(args)=><FinancialService {...args}/>} />
                            <Route exact path="/billing-service" component={(args)=><BillingService {...args}/>} />
                            <Route exact path='/collectives' component={(args)=><Collective {...args}/>} />
                            <Route exact path='/agriminer' component={(args)=><AgriMinerComponent {...args}/>} />
                            <Route exact path="/agri-inputs-marketplace" component={ExploreCareProducts}/>
                            <Route exact path="/agri-service-marketplace" component={(args)=><AgriServiceMarketplace {...args}/>} />
                            <Route exact path='/Agent' component={(args)=><Agent {...args}/>} />
                            <Route exact path='/Terms&Conditions' component={(args)=> <TermsComponent {...args}/>}/>
                            <Route exact path='/PrivacyPolicy' component={(args)=> <PrivacyComponent {...args}/>}/>
                            <Route path="/auth" component={(args) => <AuthRoute {...args}/>} />
                            <Route path="/main" component={(args) => <MainRoute {...args}/>} />

                            <Route component={(args) => <Redirect to={"/"} />} />
                        </Switch>
                        </ScrollToTop>

                    </Router>
                    <NotificationContainer />
                </ThemeProvider>
            // </StyledEngineProvider>
        );
    }
}

ReactDOM.render(<IndexComponent />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

